import { GQLAvailablePromoServices } from 'generated-graphql/graphql'

export interface ForeignProfileState {
  hitId: number
  availablePromoServices: GQLAvailablePromoServices[]
  imageUrlWidget: string | null
  updateProfile: boolean
  foreignPromoMtsStatusLoading: boolean
  foreignPromoMtsStatus: string | null
  gqlError: string | null
}

export const initialState: ForeignProfileState = {
  hitId: 0,
  availablePromoServices: [],
  imageUrlWidget: null,
  updateProfile: false,
  foreignPromoMtsStatusLoading: true,
  foreignPromoMtsStatus: null,
  gqlError: null,
}
